import { put, call, takeEvery, takeLatest } from 'redux-saga/effects';

import {
  createNotification,
  deleteNotification,
  fetchNotifications,
  fetchNotificationById,
  fetchNotificationLogs,
  fetchNotificationStats,
  bulkDeleteNotifications,
} from '../apis/notification';
import {
  getNotificationsAction,
  getNotificationsSuccess,
  getNotificationsFailure,
  createNotificationAction,
  deleteNotificationAction,
  createNotificationSuccess,
  createNotificationFailure,
  deleteNotificationSuccess,
  deleteNotificationFailure,
  getNotificationByIdAction,
  getNotificationLogsAction,
  getNotificationByIdSuccess,
  getNotificationByIdFailure,
  getNotificationLogsSuccess,
  getNotificationLogsFailure,
  getNotificationStatsAction,
  getNotificationStatsSuccess,
  getNotificationStatsFailure,
  bulkDeleteNotificationsAction,
  bulkDeleteNotificationsSuccess,
  bulkDeleteNotificationsFailure,
} from '../slices/notification';

function* getNotifications(action) {
  try {
    const response = yield call(fetchNotifications, action.payload);
    yield put(getNotificationsSuccess(response));
  } catch (error) {
    yield put(
      getNotificationsFailure(
        error.response?.data?.error?.message || error.message || 'Failed to fetch notifications'
      )
    );
  }
}

function* getNotificationById(action) {
  try {
    const response = yield call(fetchNotificationById, action.payload);
    yield put(getNotificationByIdSuccess(response));
  } catch (error) {
    yield put(
      getNotificationByIdFailure(
        error.response?.data?.error?.message || error.message || 'Failed to fetch notification'
      )
    );
  }
}

function* handleCreateNotification(action) {
  try {
    yield call(createNotification, action.payload);
    yield put(createNotificationSuccess());
  } catch (error) {
    yield put(
      createNotificationFailure(
        error.response?.data?.error?.message || error.message || 'Failed to create notification'
      )
    );
  }
}

function* handleDeleteNotification(action) {
  try {
    yield call(deleteNotification, action.payload);
    yield put(deleteNotificationSuccess());
  } catch (error) {
    yield put(
      deleteNotificationFailure(
        error.response?.data?.error?.message || error.message || 'Failed to delete notification'
      )
    );
  }
}

function* handleBulkDeleteNotifications(action) {
  try {
    const { ids, params } = action.payload;
    yield call(bulkDeleteNotifications, ids);
    yield put(bulkDeleteNotificationsSuccess());
    // Refetch the page and filters the user is on.
    yield put(getNotificationsAction(params));
  } catch (error) {
    yield put(
      bulkDeleteNotificationsFailure(
        error.response?.data?.error?.message || error.message || 'Failed to delete notifications'
      )
    );
  }
}

function* getNotificationLogs(action) {
  try {
    const response = yield call(fetchNotificationLogs, action.payload);
    yield put(getNotificationLogsSuccess(response));
  } catch (error) {
    yield put(
      getNotificationLogsFailure(
        error.response?.data?.error?.message || error.message || 'Failed to fetch delivery logs'
      )
    );
  }
}

function* getNotificationStats(action) {
  try {
    const response = yield call(fetchNotificationStats, action.payload);
    yield put(getNotificationStatsSuccess(response));
  } catch (error) {
    yield put(
      getNotificationStatsFailure(
        error.response?.data?.error?.message || error.message || 'Failed to fetch delivery stats'
      )
    );
  }
}

export default function* notificationSaga() {
  yield takeLatest(getNotificationsAction.type, getNotifications);
  yield takeEvery(getNotificationByIdAction.type, getNotificationById);
  yield takeEvery(createNotificationAction.type, handleCreateNotification);
  yield takeEvery(deleteNotificationAction.type, handleDeleteNotification);
  yield takeLatest(bulkDeleteNotificationsAction.type, handleBulkDeleteNotifications);
  yield takeLatest(getNotificationLogsAction.type, getNotificationLogs);
  yield takeEvery(getNotificationStatsAction.type, getNotificationStats);
}
